import HomeSupplier from './HomeSupplierPage';

export default HomeSupplier;
